import { Brain, SearchStrategy, SearchStrategyMode, Tool } from '@/shared/types/brain';

type BrainToolsState = Pick<Brain, 'tools' | 'search_strategy' | 'collection_id'>;

export const getSearchStrategy = (brain: Pick<Brain, 'search_strategy'> | undefined) =>
  ({
    mode: brain?.search_strategy?.mode ?? SearchStrategyMode.PREFETCH,
    max_results: brain?.search_strategy?.max_results ?? null,
  }) satisfies SearchStrategy;

export const useEffectiveTools = (brain: BrainToolsState | undefined) => {
  const requiredTools =
    brain?.search_strategy?.mode === SearchStrategyMode.ON_DEMAND && brain.collection_id
      ? [Tool.SEARCH_KNOWLEDGE_BASE]
      : [];
  const storedTools = brain?.tools ?? [];
  const missingTools = requiredTools.filter((tool) => !storedTools.includes(tool));
  return { requiredTools, effectiveTools: [...storedTools, ...missingTools] };
};
